var map = {
	"./da.json": 49914,
	"./de.json": 95894,
	"./el.json": 94524,
	"./en.json": 44174,
	"./es.json": 46725,
	"./fr.json": 94605,
	"./hu.json": 86938,
	"./it.json": 83672,
	"./ja.json": 87980,
	"./pl.json": 11029,
	"./pt.json": 37741,
	"./ru.json": 74600,
	"./sv.json": 28252,
	"./tr.json": 79755,
	"./zh.json": 79527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5432;